/**
 * Ingredient Checker
 * =====================================================================
 */
 (function() {
   const ingredientCheckerPage = document.querySelector('#ingredient-checker-id'); 
   const badList = [
    "Isopropanol",
    "Propylparaben",
    "N-Propanol",
    "Butylparaben",
    "Butanol",
    "Isobutylparaben",
    "Isobutanol",
    "Pentylparaben",
    "Pentanol",
    "Heptylparaben",
    "Heptanol",
    "Benzylparaben",
    "Benzyl Alcohol",
    "Pentylparaben",
    "Pentyl Alcohol",
    "retinol",
    "retinaldehyde",
    "retinyl esters",
    "tretinoin",
    "adapalene",
    "tazarotene",
    "trifarotene",
    "isotretinoin",
    "retinoid",
    "Titanium Dioxide",
    "Titanium White",
    "Rutile",
    "Dioxo-Titanium",
    "Titania",
    "Tioxide",
    "Sodium Benzoate",
    "Sodium Benzoate",
    "Benzoic Acid",
    "Sodium Salt",
    "Sobenate",
    "Nitrates",
    "NO3",
    "BHT",
    "BHA",
    "butylated hydroxyanisole",
    "butylated hydroxytoluene",
    "butylhydroxytoluene",
    "INS NO 321",
    "Sodium Aluminum Phosphate",
    "Sodium Aluminum Sulfate",
    "Aluminum Silicate",
    "aluminum sodium salt",
    "soda alum",
    "sodium alum",
    "SAS",
    "kaolin",
    "hydrated aluminum silicate",
    "aluminum chloride",
    "Aluminum trichloride",
    "BPA",
    "bisphenol A",
    "bisphenol ",
    "Isopropylidenediphenol",
    "Diphenylolpropane",
    "Parabis A",
    "Phenol",
    "Dihydroxydiphenylpropane",
    "Pluracol",
    "Dimethylmethylene",
    "Carrageenan",
    "PES",
    "processed Eucheuma seaweed",
    "Chondrus",
    "Carrageenin",
    "irish moss",
    "Vegetable Gelatin",
    "Norsk Gelatin",
    "Danish Agar",
    "Carastay",
    "Eucheuma spinosum gum",
    "Marine colloids",
    "Red seaweed",
    "Rhodophyceae",
    "Poligeenan",
    "Polygeenan",
    "ortho-hydroxybenzoic acid",
    "Salicylic Acid",
    "Red No 3",
    "Red No 4",
    "Yellow No 5",
    "Yellow No 6",
    "Blue No 1",
    "Blue No 2",
    "Nitrate",
    "Parabens",
    "Retinoids"
   ]
   const badListLower = badList.map(ingredient => ingredient.toLowerCase())

   const badList2 = [
    "Paraben",
    "Methylparaben",
    "Methanol",
    "Ethylparaben",
    "Isopropylparaben",
    "Isopropanol",
    "Propylparaben",
    "N-Propanol",
    "Butylparaben",
    "Butanol",
    "Isobutylparaben",
    "Isobutanol",
    "Pentylparaben",
    "Pentanol",
    "Heptylparaben",
    "Heptanol",
    "Benzylparaben",
    "Benzyl Alcohol",
    "Pentylparaben",
    "Pentyl Alcohol",
    "retinol",
    "retinaldehyde",
    "retinyl esters",
    "tretinoin",
    "adapalene",
    "tazarotene",
    "trifarotene",
    "isotretinoin",
    "retinoid",
    "benzophenone",
    "Milestab",
    "Eusolex",
    "Escalol",
    "oxybenzone",
    "KAHSCREEN",
    "Salicylic Acid",
    "ortho hydroxybenzoic acid",
    "Red No 3",
    "Red No 40",
    "Yellow No 5",
    "Yellow No 6",
    "Blue No 1",
    "Blue No 2",
    "BHT",
    "BHA",
    "butylated hydroxyanisole",
    "butylated hydroxytoluene",
    "butylhydroxytoluene",
    "INS NO 321",
    "Formaldehyde",
    "Formalin",
    "Formic aldehyde",
    "Methanediol",
    "Methanal",
    "Methyl aldehyde",
    "Methylene glycol",
    "Methylene oxide",
    "Benzylhemiformal",
    "Sodium Aluminum Phosphate",
    "Sodium Aluminum Sulfate",
    "Aluminum Silicate",
    "aluminum sodium salt",
    "soda alum",
    "sodium alum",
    "SAS",
    "kaolin",
    "hydrated aluminum silicate",
    "aluminum chloride",
    "Aluminum trichloride",
    "Dihydroxyacetone",
    "Dihydroxypropan",
    "Dihydroxypropanone",
    "Glycerone",
    "Triulose",
    "Viticolor",
    "DHA",
    "Quinol",
    "Benzenediol",
    "Hydroquinone",
    "Benzene",
    "Diphenol",
    "Dihydroxybenzene",
    "Hydrochinone",
    "Hydroxylphenol",
    "Hydrochinonium",
    "Hydroquinol",
    "Tequinol",
    "Parabens",
    "Retinoids",
    // "Sodium Benzoate",
    "Benzoic Acid",
    "Sodium Salt",
    "Sobenate"
 ]
 const badListLower2 = badList2.map(ingredient => ingredient.toLowerCase())

    if (ingredientCheckerPage) {
      const $checkerClear = $('[js-button-clear]');
      const $tabButton = $('[js-tab-check]');
      const $checkerSubmit = $('[js-button-submit]');
      const $checkerWarning = $('[js-checker-bad]');
      const $checkerConfirm = $('[js-checker-good]');
      const $listTextArea = $('[js-ingredient-check]');
      let $badIngredients = $('[js-bad-ingredients]');

      $checkerClear.on('click', function(evt){
        evt.preventDefault();
        $listTextArea.val('');

        if($checkerClear.hasClass('ingredient-checker__tall-button--disabled')) {
          //do nothing
        } else {
          $checkerClear.addClass('ingredient-checker__tall-button--disabled');
        }
      })

      $listTextArea.on('keyup', function(evt) {
        console.log('check', $listTextArea.val().length)
        if($listTextArea.val().length > 0) {
          if($checkerClear.hasClass('ingredient-checker__tall-button--disabled')) {
            $checkerClear.removeClass('ingredient-checker__tall-button--disabled');
          }
        } else {
          if($checkerClear.hasClass('ingredient-checker__tall-button--disabled')) {
            //do nothing
          } else {
            $checkerClear.addClass('ingredient-checker__tall-button--disabled');
          }
        }
      })

      $tabButton.on('click', function(evt){
        evt.preventDefault();
        let $category = $('[js-check-category]');
        var dataCategory = $(this).data('category');
        $category.attr('js-category-name', dataCategory);

        if($(this).hasClass('ingredient-checker__tab-button--selected')) {
          //do nothing
        } else {
          $(this).addClass('ingredient-checker__tab-button--selected');
          $(this).siblings().removeClass('ingredient-checker__tab-button--selected');
        }
        console.log('1')
        if($category.attr('js-category-name') !== 'NULL') {
          console.log('2')
          if($checkerSubmit.hasClass('ingredient-checker__tall-button--disabled')) {
            console.log('3')
            $checkerSubmit.removeClass('ingredient-checker__tall-button--disabled');
          }
        }
      })

      $checkerSubmit.on('click', function(evt){
        evt.preventDefault();
        let $category = $('[js-check-category]');
        let listOfIngredients = $listTextArea.val();
        let splitIngredients = listOfIngredients.split(',');
        let splitIngredientsLower = splitIngredients.map(ingredient => ingredient.trim().toLowerCase())
        // const matchFound = splitIngredientsLower.some(ingredient => badListLower.includes(ingredient));
        if($category.attr('js-category-name') == 'ingestible') {
          console.log('category hi', $category.attr('js-category-name'))
          let foundTerms = [...new Set(splitIngredientsLower.filter(ingredient => badListLower.includes(ingredient)))]

          console.log('intersection', foundTerms)

          if(foundTerms.length) {
            $checkerConfirm.hide()
            $checkerWarning.hide()
            setTimeout(function(){
              $checkerWarning.show()
            }, 200)
            
            $badIngredients.html('');
            foundTerms.map(function(ingredient){
              console.log('ingredient', ingredient);
              let ingredientDiv = '<div class="ingredient-checker__bad-ingredient">' + ingredient + '</div>'
              $badIngredients.append(ingredientDiv);
            })
          } else {
            $checkerWarning.hide()
            $checkerConfirm.hide()
            setTimeout(function(){
            $checkerConfirm.show()
            },200)
          }
        } else {
          console.log('category wow', $category.attr('js-category-name'))
          let foundTerms = [...new Set(splitIngredientsLower.filter(ingredient => badListLower2.includes(ingredient)))]

          console.log('intersection', foundTerms)

          if(foundTerms.length) {
            $checkerConfirm.hide()
            $checkerWarning.hide()
            setTimeout(function(){
            $checkerWarning.show()
            },200)
  
            $badIngredients.html('');
            foundTerms.map(function(ingredient){
              console.log('ingredient', ingredient);
              let ingredientDiv = '<div class="ingredient-checker__bad-ingredient">' + ingredient + '</div>'
              $badIngredients.append(ingredientDiv);
            })
          } else {
            $checkerWarning.hide()
            $checkerConfirm.hide()
            setTimeout(function(){
            $checkerConfirm.show()
            },200)
          }
        }



      })

      var selectors = {
        container: '[js-accordion-group]',
        header: '[js-accordion-header]',
        content: '[js-accordion-content]'
      }

      // $(selectors.header).eq(0).attr('aria-expanded', true);
      // $(selectors.content).eq(0).slideDown().attr('aria-hidden', false);
  
      $('body').on('click', selectors.header, function(evt){
        var $el = $(this);
        if($el.attr('aria-expanded') == 'true'){
          //this stops the slide up triggering the parent;
          $el.siblings().slideUp(400, function() {
            $(this).attr('aria-hidden', true);
          })
          // This is closing the children accordions when the parent accordion is closed.
          $el.siblings(selectors.content).find(selectors.header).each(function(){
            $(this).attr('aria-expanded', false);
            $(this).siblings(selectors.content).slideUp(400, function() {
              $(this).attr('aria-hidden', true);
            });
          })
          $el.attr('aria-expanded', false);
        } else {
          $el.parent().siblings().find(selectors.content, selectors.container).slideUp(400, function(){
            $(this).attr('aria-hidden', true);
          });
          $el.parent().siblings().find(selectors.header, selectors.container).attr('aria-expanded', false);
          $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
          $el.attr('aria-expanded', true);
        }
      })
      
    }
  
  })()


  
